import { Box } from '@mui/material';
import { PaginationIndicator } from 'ogp/components/common/pagination-indicator';
import { useLevelPagination } from 'ogp/hooks/queryHooks/misc/use-level-pagination';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { ExternalFlexPoolsTable } from './table';
import { useGetExternalFlexPools } from '../../hooks/use-get-external-flex-pools';

export const ExternalFlexPools = () => {
  const pagination = useLevelPagination();
  const flexPoolListQuery = useGetExternalFlexPools({
    page: pagination.page,
    pageSize: pagination.size,
  });

  if (flexPoolListQuery.status !== 'success') {
    return <RenderUnsettledUI data={flexPoolListQuery} />;
  }

  const { items, totalRows } = flexPoolListQuery.data;

  return (
    <Box display="flex" width="100%" maxHeight={'100%'} flexDirection={'column'}>
      <ExternalFlexPoolsTable data={items} />
      <Box mt="auto">
        <PaginationIndicator pageCount={totalRows} pagination={pagination} />
      </Box>
    </Box>
  );
};
